export interface SystemState {
  ProfilePermissions: Array<ProfilePermissions>;
  SystemConfig: SystemConfig;
  PagesConfig: {
    home: HomeConfig;
  };
  SystemCatalogs: {
    countries: Map<string, Country>;
  };
  SystemConfigListeners: {
    SysConfigListener: () => void;
    pages: {
      homeConfigListener: () => void;
    };
  };
  BotsData: BotsData;
}

export interface SystemConfig {
  offline: boolean;
  slogan: Array<string>;
  "cody-widget_id": string;
  displayedMinimumPaymentAmount: number;
}

export interface HomeConfig {
  modal: {
    active: boolean;
    image?: {
      src: string;
      alt: string;
    };
  };
  notices: {
    left: NoticeSection;
    middle: NoticeSection;
    wide: NoticeSection;
  };
  videos: VideosSection;
}

export interface NoticeSection {
  active: boolean;
  images: Array<NoticeParams>;
}
export interface NoticeParams {
  src: string;
  alt: string;
  link?: string;
  interval?: number | 8000;
  priority: number | 0;
  active: boolean | true;
}

export interface VideosSection {
  active: boolean | true;
  playlist: Array<VideoParams>;
}
export interface VideoParams {
  active: boolean;
  priority: number;
  src: string;
  title: string;
  interval: number | 10000;
  button?: {
    href: string;
    icon: string;
    title: string;
    visible: boolean;
  };
}

export interface BotsData {
  telegram: {
    username: string;
  };
}

export interface Country {
  readonly alpha3Code: string;
  readonly alpha2Code: string;
  readonly enabled: boolean;
  readonly priority: number;
  readonly starred: boolean;
  readonly spanish: string;
  readonly english: string;
  readonly french: string;
  readonly dialCode?: string;
}

// export const Menu = {
//   _UserMenu: [
//     // eslint-disable-next-line
//     new MenuItem(100, "home", "Inicio", "bi bi-clipboard-data", "red", "/home"),
//     // eslint-disable-next-line
//     new MenuItem(200, "subscriptions", "Suscripciones", "bi bi-award","indigo", "/subscriptions"),
//     // eslint-disable-next-line
//     new MenuItem(300, "commissions", "Comisiones", "bi bi-wallet2","green", "/commissions"),
//     // eslint-disable-next-line
//     new MenuItem(400, "withdrawals", "Retiros", "fa fab fa-bitcoin","yellow", "/withdrawals"),
//     // eslint-disable-next-line
//     new MenuItem(500, "payments", "Pagos Realizados", "bi bi-credit-card","cyan", "/payments"),
//     // eslint-disable-next-line
//     new MenuItem(600, "unilevel", "Afiliados", "bi bi-diagram-3","orange", "/unilevel"),
//     // eslint-disable-next-line
//     new MenuItem(700, "binary-network", "Red Binaria", "bi bi-diagram-2","purple", "/binary-network"),
//     // eslint-disable-next-line
//     new MenuItem(800, "profile", "Mi Perfil", "bi bi-person","blue", "/profile"),
//     // eslint-disable-next-line
//     new MenuItem(900, "queries", "Consultas", "bi bi-card-list","pink", "/queries"),
//     // eslint-disable-next-line
//     new MenuItem(1010, "channels", "Canales", "bi bi-chat-text","teal", "/channels"),
//     // eslint-disable-next-line
//     new MenuItem(1020, "alerts", "Alertas", "bi bi-broadcast-pin","red", "/alerts"),
//     // eslint-disable-next-line
//     //move to SysAdmin Menus
//     new MenuItem(
//       2000,
//       "sys-config",
//       "System Configuration",
//       "fa fas fa-cogs",
//       "red",
//       "/sys-config"
//     )
//     //new MenuItem(1020, "marketplace", "Marketplace", "bi bi-shop","teal", "marketplace"),
//   ]
// // };

// const _NetworkAdminMenu: Array<MenuItem> = [];
// const _RootMenu: Array<MenuItem> = [];
// const _SysAdminMenu: Array<MenuItem> = [];
// const _TraderMenu: Array<MenuItem> = [];

// export interface SystemMenus {
//   UserMenu: Array<MenuItem>;
//   NetworkAdminMenu: Array<MenuItem>;
//   RootMenu: Array<MenuItem>;
//   SysAdminMenu: Array<MenuItem>;
//   TraderMenu: Array<MenuItem>;
// }

// export const SystemMenus: SystemMenus = {
//   UserMenu: Menu._UserMenu,
//   NetworkAdminMenu: _NetworkAdminMenu,
//   RootMenu: _RootMenu,
//   SysAdminMenu: _SysAdminMenu,
//   TraderMenu: _TraderMenu
// };

export interface ProfilePermissions {
  profileId: string;
  active?: boolean;
  data?: Array<string>;
}

export const GET_PROFILES_CONFIG_SUCCESS = "GET_PROFILES_CONFIG_SUCCESS";
export const SET_SYSTEM_CONFIG = "SET_SYSTEM_CONFIG";
export const SET_HOME_CONFIG = "SET_HOME_CONFIG";
export const SET_BOTS_DATA = "SET_BOTS_DATA";
export const SET_CONFIG_LISTENER = "SET_CONFIG_LISTENER";
export const SET_HOME_CONFIG_LISTENER = "SET_HOME_CONFIG_LISTENER";
export const CLEAR_CONFIG_LISTENERS = "CLEAR_CONFIG_LISTENERS";
export const CLEAR_CONFIG_LISTENER = "CLEAR_CONFIG_LISTENER";
export const CLEAR_HOME_CONFIG_LISTENER = "CLEAR_HOME_CONFIG_LISTENER";
export const SET_SYSTEM_CATALOG_COUNTRIES = "SET_SYSTEM_CATALOG_COUNTRIES";
export const SET_SYSTEM_CATALOG_COUNTRIES_LISTENER =
  "SET_SYSTEM_CATALOG_COUNTRIES_LISTENER";
export const CLEAR_SYSTEM_CATALOG_COUNTRIES_LISTENER =
  "CLEAR_SYSTEM_CATALOG_COUNTRIES_LISTENER";
